// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Projects/';
export const ProjectActionTypes = {
  ANNOUNCEMENTS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'ANNOUNCEMENTS'
  ),
  GALLERY: ActionHelper.createActionTypes(actionTypePrefix, 'GALLERY'),
  PROJECTS: ActionHelper.createActionTypes(actionTypePrefix, 'PROJECTS'),
  PROJECT_FILTERS: {
    INITIALIZE: `${actionTypePrefix}/PROJECT_FILTERS_INITIALIZE`,
    TOGGLE_FILTER: `${actionTypePrefix}/PROJECT_FILTERS_TOGGLE_FILTER`,
    CLEAR_FILTERS: `${actionTypePrefix}/PROJECT_FILTERS_CLEAR_FILTERS`,
  },
  NEIGHBOURHOOD_GUIDE: ActionHelper.createActionTypes(
    actionTypePrefix,
    'NEIGHBOURHOOD_GUIDE'
  ),
  NEIGHBOURHOOD_FILTERS: {
    TOGGLE_FILTER: `${actionTypePrefix}/NEIGHBOURHOOD_FILTERS_TOGGLE_FILTER`,
    INITIALIZE_FILTER: `${actionTypePrefix}/NEIGHBOURHOOD_FILTERS_INITIALIZE_FILTER`,
  },
  CONSTRUCTION_GALLERY: ActionHelper.createActionTypes(
    actionTypePrefix,
    'CONSTRUCTION_GALLERY'
  ),
  COMPLETED_PROJECTS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'COMPLETED_PROJECTS'
  ),
  PROJECT_BROCHURE: ActionHelper.createActionTypes(
    actionTypePrefix,
    'PROJECT_BROCHURE'
  ),
};
